module.exports = __webpack_public_path__ + "static/media/pink_sky.a5df5764.jpg";